import { render, staticRenderFns } from "./BusinessContactCreate.vue?vue&type=template&id=179f322d"
import script from "./BusinessContactCreate.vue?vue&type=script&lang=js"
export * from "./BusinessContactCreate.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports